import { useLocalStorage } from '@festina-life/ui/hooks'

import { useHook } from '../lenteHooks'

export const useScenarioOverviewDefaultDiff = () => {
  const { ownerId, tenantId } = useHook('routing.general.useEntityParams')()
  // For new participants we can't diff by default because there are no commands outside. This would result in an error
  const { data: hasActiveCommands } = useHook(
    'fetchers.life.useFetchCommitmentCommands',
  )(
    { ownerId, tenantId },
    {
      select: (data) =>
        !!data?.abstractCommandVersions
          ?.flatMap((x) => x?.commandStepVersions)
          .flatMap((x) => x?.eventVersions)
          .some((x) => !x?.rolledBackTime),
    },
  )

  const [isDiffingByDefault, setIsDiffingByDefault] = useLocalStorage<boolean>(
    'scenarioOverview.isDiffingByDefault',
    true,
  )

  const isDisabled = !hasActiveCommands

  return hasActiveCommands
    ? { isDiffingByDefault, setIsDiffingByDefault, isDisabled }
    : { isDiffingByDefault: false, setIsDiffingByDefault, isDisabled }
}
